import React from 'react';
import { Text, Modal, Button } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';

const DeleteCidrModal = ({ isOpened, onClose, handleUpdate }) => {
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={350}
      id="modal-update-cidr-access"
    >
      <ModalHeader onClose={onClose}>
        <Text size="xlarge" fontWeight="semibold" color="secondaryText" mb={15}>
          Pause IP Access Restriction?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="small" color="secondaryText">
          Are you sure you want to pause this control? Pausing this control will
          allow users to log in outside of the agency and/or outside of the
          specified IP addresses.
        </Text>
      </ModalBody>
      <ModalFooter flow={12} justify="center">
        <Button btnType="primary" onClick={handleUpdate} grow>
          Confirm
        </Button>
        <Button btnType="tertiary" grow onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteCidrModal;
